/**
 * Flächen-Zeitleiste einer Einheit (Spec 2026-09-13, Sektion 3.2).
 *
 * `unitAreaForMonth` liefert die am Monatsanfang gültige Fläche aus `areaChanges` (nur APPLIED-Einträge,
 * vom Adapter sortiert): der Eintrag mit dem größten `startDate ≤ Monatsanfang`; ein Eintrag ohne
 * `startDate` ist die Ausgangsfläche „seit Beginn“. Ohne Zeitleiste (null/leer) oder wenn kein Eintrag
 * am Monatsanfang gilt (alle in der Zukunft), zählt `unit.area`. Reines TypeScript.
 *
 * @author Anthony Nahas
 * @since 13.09.26
 */
import {monthStart} from './month';
import type {UnitLite} from './types';

export const unitAreaForMonth = (unit: Pick<UnitLite, 'area' | 'areaChanges'>, monthKey: string): number | null => {
    const changes = unit.areaChanges;
    if (!Array.isArray(changes) || changes.length === 0) {
        return unit.area;
    }
    const startOfMonth = monthStart(monthKey).getTime();
    let best: { time: number; area: number } | null = null;
    for (const change of changes) {
        if (!Number.isFinite(change?.area)) {
            continue;
        }
        const time = change.startDate instanceof Date ? change.startDate.getTime() : Number.NEGATIVE_INFINITY;
        if (time <= startOfMonth && (best === null || time >= best.time)) {
            best = {time, area: change.area};
        }
    }
    return best ? best.area : unit.area;
};
